import { HorizontalContainer, IconButton, Tooltip } from '@/components';
import { InfoIcon } from '@/components/Icons';
import { showInsurancePolicyProviderDetailsModal } from '@/features/insurancePolicyProviderDetails';
import { cn } from '@/lib/cn';
import { ICompanyDto, IPatientDto } from '@/shared/interfaces';

import { R } from '@/caregiverSpace/resources/Texts.resx';

import { useNavigation } from '@/caregiverSpace/shared/lib';
import { GoToPageButton } from '@/caregiverSpace/shared/ui';

type AccessViaViewProps = {
    company: ICompanyDto;
    className?: string;
    accessVia?: IPatientDto;
};

export const AccessViaView = ({
    company,
    className,
    accessVia,
}: AccessViaViewProps) => {
    const { goToPatientPage } = useNavigation();

    if (company) {
        return (
            <HorizontalContainer className="items-center" spacing="xs">
                <span className={cn('h-full font-bold', className)}>
                    {company.CompanyName}
                </span>
                {company.InsurancePolicyProvider && (
                    <IconButton
                        tooltip={R.ReadMore}
                        onClick={() => {
                            showInsurancePolicyProviderDetailsModal({
                                insurancePolicyProviderType:
                                    company.InsurancePolicyProvider,
                            });
                        }}
                        icon={<InfoIcon variant="action" />}
                    />
                )}

                {accessVia && (
                    <>
                        {R.Via}
                        <div>
                            <GoToPageButton
                                onClick={() =>
                                    goToPatientPage(accessVia.User.ID)
                                }
                            >
                                {accessVia.User.FullName}
                            </GoToPageButton>
                        </div>
                    </>
                )}
            </HorizontalContainer>
        );
    }

    return <span className={cn('font-bold', className)}>{R.OwnPayment}</span>;
};
